import * as React from 'react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import questionGroups from 'modules/surveys/store/collections/questionGroups'
import QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

export function useQuestionGroup(questionGroupId: string): {
  loading: boolean
  questionGroup: QuestionGroup | null | undefined
  refresh: () => Promise<void>
} {
  const [questionGroup, setQuestionGroup] = React.useState(questionGroups.get(questionGroupId))

  const fetchQuestionGroup = async () => {
    if (questionGroup) {
      return questionGroup.fetch()
    }

    setQuestionGroup(
      await QuestionGroup.fetch({
        id: questionGroupId.toString(),
      })
    )
  }

  const { loading } = useUnsafeAsyncData(fetchQuestionGroup, [])

  return {
    loading,
    questionGroup,
    refresh: fetchQuestionGroup,
  }
}
